module.exports = __webpack_public_path__ + "img/pos-leaderboard-badge-rank-2.2b1d1a88.svg";